import React from "react";
import { useFooterLayouts } from "../../../hooks/apis/main";
function Footer_copyright() {
  const { data, isLoading, error } = useFooterLayouts();

  if (isLoading)
    return (
      <div className="active loading">
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );
  if (error) return <p>Error</p>;
  return (
    <div className="footer-copyright">
      <div className="container">
        <p className="text">
          طراحی اختصاصی سایت و پیاده سازی توسط شرکت &nbsp;
          <a href="https://afrozweb.com/" target="_blank">
            افروز پیشگامان پاسارگاد
          </a>
        </p>
        <div className="socials">
          <a
            href={`https://t.me/${data.social_medias[3].value.replace(
              /_/,
              ""
            )}`}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-telegram"></i>
          </a>
          <a
            href={data.social_medias[4].value.replace(/_/g, "")}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
          <a
            href={`https://instagram.com/${data.social_medias[5].value}`}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer_copyright;
